// src/components/ColorPickerModal.jsx

import React, { useState } from 'react';
import { HexColorPicker } from 'react-colorful';

const ColorPickerModal = ({ initialPositive, initialNegative, onSave, onClose }) => {
  const [editingTarget, setEditingTarget] = useState('positive'); // 'positive' o 'negative'
  const [positiveColor, setPositiveColor] = useState(initialPositive);
  const [negativeColor, setNegativeColor] = useState(initialNegative);

  const currentColor = editingTarget === 'positive' ? positiveColor : negativeColor;
  const setCurrentColor = editingTarget === 'positive' ? setPositiveColor : setNegativeColor;

  const handleSave = () => {
    onSave(positiveColor, negativeColor);
    onClose();
  };

  return (
    <>
      <div className="settings-overlay" onClick={onClose}></div>
      <div className="color-picker-modal">
        <h4>Personalizar Colores de Estilo</h4>
        <div className="color-picker-content">
          <div className="color-picker-controls">
            <div className="target-buttons">
              <button
                className={editingTarget === 'positive' ? 'active' : ''}
                onClick={() => setEditingTarget('positive')}
              >
                Sube
              </button>
              <button
                className={editingTarget === 'negative' ? 'active' : ''}
                onClick={() => setEditingTarget('negative')}
              >
                Baja
              </button>
            </div>
            <div className="color-preview" style={{ backgroundColor: currentColor }}>
              {currentColor}
            </div>
          </div>
          <HexColorPicker color={currentColor} onChange={setCurrentColor} />
        </div>
        <div className="modal-footer">
          <button className="delete-btn" onClick={onClose}>Cancelar</button>
          <button className="cta-button" onClick={handleSave}>Confirmar</button>
        </div>
      </div>
    </>
  );
};

export default ColorPickerModal;